import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClearIcon from '@mui/icons-material/Clear';
import { Grid, Button, Skeleton } from '@mui/material';
import EngrenagemIcon from '../Sidebar/icons/Engrenagem';
import { ReactComponent as SinoNotificacaoAlertIcon } from '../Sidebar/icons/notification_alert.svg';
import { ReactComponent as SinoNotificacaoIcon } from '../Sidebar/icons/notification.svg';
import {
  getCodDepartamentoSession,
  setDepartamentoSelecionadoSession
} from '../../../services/authentication/auth';
import './styles.scss';

export default function MenuDepartamentosMobile({
  setMenuDepartamentoSideBar,
  setDepartamentoSelecionado,
  navegarParaConfiguracoes,
  menuDepartamentoSideBar,
  isPendingDepartamento,
  lstItensDepartamento,
  setAlertSideBarOpen,
  qtdIconeNotificacao,
  setMenuOpen
}) {
  const selecionarDepartamento = codDepartamento => {
    if (codDepartamento) {
      const depObj = lstItensDepartamento.find(item => item.id === codDepartamento);
      if (depObj) {
        setDepartamentoSelecionadoSession(depObj);
      }
      setDepartamentoSelecionado(codDepartamento);
      setMenuDepartamentoSideBar(false);
      setMenuOpen(true);
    }
  };

  const abrirConfiguracoes = () => {
    setMenuDepartamentoSideBar(false);
    navegarParaConfiguracoes();
  };

  const abrirAlertas = () => {
    setMenuDepartamentoSideBar(false);
    setAlertSideBarOpen(true);
  };

  return (
    <Drawer
      className="alert-sidebar"
      open={menuDepartamentoSideBar}
      onClose={() => setMenuDepartamentoSideBar(false)}
      anchor="left"
    >
      <Box role="presentation">
        <Box className="menu-sidebar-header">
          <Grid container className="header-sidebar-container">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box>
                <Button className="btn-close" onClick={() => setMenuDepartamentoSideBar(false)}>
                  <ClearIcon />
                </Button>
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box className="box-menu">
              <Box onClick={() => abrirConfiguracoes()} className="icones-menu engrenagem-icon">
                <EngrenagemIcon className="icon-notificacao engrenagem-icon" />
                <Box className="texto-icon">Configurações</Box>
              </Box>
              <Box onClick={() => abrirAlertas()} className="icones-menu">
                {qtdIconeNotificacao && <SinoNotificacaoAlertIcon className="icone-sino-notificacao" />}
                {!qtdIconeNotificacao && <SinoNotificacaoIcon className="icone-sino-notificacao" />}
                <Box className="texto-icon">Notificações</Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {isPendingDepartamento && (
              <Grid item xs={9} sm={9} md={9} lg={10} xl={10} className="pad-left-5">
                <Skeleton variant="text" width="100%" height={35} />
                <Skeleton variant="rectangular" width="100%" height={30} />
                <Skeleton variant="text" width="100%" height={35} />
                <Skeleton variant="rectangular" width="100%" height={30} />
                <Skeleton variant="text" width="100%" height={35} />
                <Skeleton variant="rectangular" width="100%" height={30} />
                <Skeleton variant="text" width="100%" height={35} />
                <Skeleton variant="rectangular" width="100%" height={30} />
              </Grid>
            )}

            {!isPendingDepartamento && (
              <Box className="box-lista-departamentos">
                {lstItensDepartamento.map((item, index) => (
                  <Box
                    key={index}
                    className={`box-item-departamento ${getCodDepartamentoSession() === item.id ? 'item-selecionado' : ''}`}
                    onClick={() => selecionarDepartamento(item.id)}
                  >
                    <Box className="box-item-departamento-texto">{item.label}</Box>
                  </Box>
                ))}
              </Box>
            )}
          </Grid>
        </Box>
      </Box>
    </Drawer>
  );
}
